var map = {
	"./AddItem.svg": "ade5",
	"./AddUser.svg": "568e",
	"./AllFiles.svg": "86d7",
	"./Assistant-1.svg": "a94b",
	"./Assistant.svg": "96ca",
	"./Attachment.svg": "7b2c",
	"./Attachment1.svg": "4621",
	"./Authorized.svg": "ba78",
	"./Baiban.svg": "d38a",
	"./BasicSetting.svg": "2741",
	"./Bidding.svg": "6865",
	"./CRM.svg": "8f3f",
	"./CRM1.svg": "1cc2",
	"./Cancel.svg": "8944",
	"./CancelFullscreen.svg": "f761",
	"./CancelSearch.svg": "9415",
	"./Cancel_1.svg": "2302",
	"./Chat.svg": "94ec",
	"./Check.svg": "aeda",
	"./CheckIn.svg": "3202",
	"./CheckOut.svg": "f481",
	"./Close.svg": "32eb",
	"./Close_1.svg": "5333",
	"./Confirm.svg": "6540",
	"./Contact.svg": "9d0b",
	"./Contract.svg": "dc91",
	"./Contract1.svg": "b90a",
	"./Contract2.svg": "73ae",
	"./Cooperation.svg": "c5ff",
	"./Customer.svg": "1978",
	"./Customer1.svg": "8687",
	"./CustomerConversion.svg": "382f",
	"./Delete.svg": "ed7c",
	"./Dimension.svg": "fb58",
	"./Down.svg": "a56f",
	"./Download.svg": "1fc7",
	"./Download1.svg": "d44a",
	"./Edit.svg": "361c",
	"./Email.svg": "1479",
	"./Excel.svg": "6b01",
	"./Exchange.svg": "34d4",
	"./ExportExcel.svg": "6af4",
	"./ExportItem.svg": "3191",
	"./Favourite.svg": "3e73",
	"./Finance.svg": "fd00",
	"./Flag_CN.svg": "194d",
	"./Flag_EU.svg": "67cb",
	"./Flag_JP.svg": "c72f",
	"./Flag_US.svg": "264b",
	"./FolderClose.svg": "cf46",
	"./FolderOpen.svg": "9e41",
	"./FollowUp.svg": "523f",
	"./Fullscreen.svg": "b0df",
	"./ImportExcel.svg": "9543",
	"./ImportItem.svg": "103e",
	"./Info.svg": "8246",
	"./Inquiry.svg": "ce4e",
	"./Invoice.svg": "bba0",
	"./Jindu.svg": "94c5",
	"./Knowledge.svg": "65a8",
	"./Library.svg": "5483",
	"./List.svg": "1fc4",
	"./Location.svg": "ecc5",
	"./Logistics.svg": "13fd",
	"./Meeting.svg": "e005",
	"./Mindmap.svg": "4e40",
	"./Moonshot.svg": "65a0",
	"./More.svg": "c8dc",
	"./MyDocument.svg": "bbca",
	"./MyFavourite.svg": "0675",
	"./MyFolder.svg": "d5ed",
	"./MyHistory.svg": "62626",
	"./MyRecycleBin.svg": "cc28",
	"./MyTemplate.svg": "2a85",
	"./New.svg": "d2eb",
	"./New_1.svg": "c385",
	"./NotePad.svg": "fc54",
	"./OneDrive.svg": "fb04",
	"./Order.svg": "007a",
	"./Payment.svg": "9ccd",
	"./Phone.svg": "fec5",
	"./Preview.svg": "a911",
	"./Procurement.svg": "05ce",
	"./Product.svg": "7412",
	"./Project.svg": "2418",
	"./Purchase.svg": "0ff1",
	"./Purchase_1.svg": "c832",
	"./Purchase_2.svg": "a075",
	"./Purchase_3.svg": "58e2",
	"./Quotation.svg": "d8ac",
	"./Recovery.svg": "1b4d",
	"./Remark.svg": "bcef",
	"./Report.svg": "cf22",
	"./Sales.svg": "14a5",
	"./Sales_1.svg": "a485",
	"./Save.svg": "b7cf",
	"./Save_1.svg": "e8e0",
	"./Scheduler.svg": "d96b",
	"./Search.svg": "bb39",
	"./Send.svg": "193e",
	"./Setting.svg": "61a7",
	"./Shipping.svg": "8c0e",
	"./Stock.svg": "2dd5",
	"./Supplier.svg": "cc9f",
	"./Target.svg": "5db1",
	"./Task.svg": "aaa4",
	"./Team.svg": "d8fb",
	"./Template.svg": "0b28",
	"./Template1.svg": "a430",
	"./Tiled.svg": "8656",
	"./Timeline.svg": "f790",
	"./ToTop.svg": "6edf",
	"./ToolBox.svg": "aaec",
	"./Transfer.svg": "b306",
	"./Tuichu.svg": "8e12",
	"./Up.svg": "5d67",
	"./Upload.svg": "1d09",
	"./User.svg": "5cd1",
	"./UserManagement.svg": "5d53",
	"./UserManagement1.svg": "105d",
	"./UserManagement2.svg": "4b37",
	"./Version.svg": "e907",
	"./Warehouse.svg": "d0a5",
	"./WarehouseShift.svg": "a398",
	"./dashboard.svg": "6fc3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6206";